import { useLocale } from "../../i18n/context";

export function Footer() {
  const { t, localePath } = useLocale();

  return (
    <footer className="bg-[#333] text-white mt-[60px]">
      <div className="max-w-[1200px] mx-auto px-5 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <h4 className="font-bold text-lg mb-1">{t.common.brand}</h4>
          <p className="text-gray-400 text-sm mb-3">{t.common.brandTagline}</p>
          <p className="text-gray-400 text-sm leading-relaxed">
            Karklėnų g. 21, Naujoji Vilnia, Vilnius 11223
          </p>
        </div>

        <div>
          <h4 className="font-bold text-lg mb-3">{t.common.footerContacts}</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li>
              <a href="tel:+37067193882" className="hover:text-white transition-colors">
                +370 671 93882
              </a>
            </li>
            <li>
              <a href="tel:+37064547376" className="hover:text-white transition-colors">
                +370 645 47376
              </a>
            </li>
            <li>
              <a href="tel:+37067795375" className="hover:text-white transition-colors">
                +370 677 95375
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-lg mb-3">{t.common.footerLinks}</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li>
              <a href={localePath("/")} className="hover:text-white transition-colors">
                {t.common.navHome}
              </a>
            </li>
            <li>
              <a href={localePath("/naudotos-padangos")} className="hover:text-white transition-colors">
                {t.common.navUsedTires}
              </a>
            </li>
            <li>
              <a href={localePath("/padangu-montavimas-ir-remontas")} className="hover:text-white transition-colors">
                {t.common.navMontavimas}
              </a>
            </li>
            <li>
              <a href={localePath("/ratlankiu-lyginimas")} className="hover:text-white transition-colors">
                {t.common.navRatlankiai}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-700 text-center py-4 text-sm text-gray-500">
        <p>
          &copy; {new Date().getFullYear()} {t.common.footerCopyright}
        </p>
      </div>
    </footer>
  );
}
